<div class="flex-vertical gap-32">
  <oui-banner
    title="Le courrier de renonciation doit être envoyé en lettre recommandée avec accusé réception, directement à l'assureur à l'adresse indiquée dans les conditions générales. Le courrier doit impérativement préciser le motif de renonciation, et une copie de ce courrier doit être déposé à l'étape suivante dans le bloc de dépôt &quot;Demande d'opération&quot;."
    declination="alert">
  </oui-banner>
  <app-specific-comment
    (onSpecificDataChanged)="onDataChange($event)"
    [initialData]="initialData"></app-specific-comment>
</div>
